(function ($, Global) {
    function BlocAboComponent() {
        // Déclaration class objet
    }

	BlocAboComponent.prototype.initEvents = function () {
		this.publishers();
	}

	BlocAboComponent.prototype.publishers = function () {
		$(document).ready(function () {
			$('.bloc-abo')
				.viewport({ max: Global.viewports.md - 1 }, function () {
					if ($('header .bloc-abo').exists()) {
						$('.bloc-abo').insertBefore('.menutop');
					}
				})
		});

		$(document).on('click', '.bloc-abo .close', function () {
			var offreId = $(this).attr('data-offreid');
			var cookieOffres = Cookie.get('TPMessageNoShow');
			var toWriteCookie = "";

			if (!cookieOffres) {
				Cookie.create('TPMessageNoShow', offreId + ', ' + new Date().getTime() + '|', 90);
			} else {
				var offres = _.compact(cookieOffres.split('|').map(function (offre) {
					return (offre) ? offre.split(',') : '';
				}));
				var offreIndex = _.findIndex(offres, function (o) { return o[0] == offreId; })

				if (offreIndex > -1) {
					offres[offreIndex][1] = new Date().getTime();
				} else {
					offres.push([offreId, new Date().getTime()]);
				}

				offres.forEach(function (item) {
					toWriteCookie += item + '|';
				});
				Cookie.create('TPMessageNoShow', toWriteCookie, 90);
			}

			$('.menutop .abo-offer[data-offreid = "' + offreId + '"]').addClass('in');
            $(this).closest('.bloc-abo').removeClass('in');
            $.Topic('init-carousel-offers').publish();
		});
	}

	Global.BlocAboComponent = BlocAboComponent;
}(jQuery, window));